
<template>
  <div class="container-fluid">
    <div>
      <div class="row card">
        <div class="card-body" id="prof">
          <div class="d-flex align-items-center justify-content-between">
            <button
              v-if="admin.role.nom == 'DE'"
              @click="new_declaration()"
              type="button"
              class="btn btn-sm bg-green text-color-green mb-3"
            >
              <span
                class="svg-size-20 svg-icon svg-icon-green svg-icon-2x mr-3"
              >
              </span>
              <span class="font-size-14 vertical-align-middle">Ajouter</span>
            </button>
          </div>
          <table
            ref="table"
            v-if="declarationsLoaded"
            id="declarationTable"
            class="table"
          >
            <thead style="background-color: #003667; color: white">
              <tr class="text-center">
                <td># Agresso</td>
                <td>Enseignant permanent</td>
                <td>Collége</td>
                <td>Volume Horaire</td>
                <td>Année universitaire</td>
                <td>Etat</td>
                <td>Responsable FC</td>
                <td>Date de création</td>
                <td>Date de validation du doyen</td>
                <td>Date de consultation de la DAF</td>
                <td></td>
              </tr>
            </thead>
            <tbody>
              <tr
                class="text-center"
                v-for="declaration in declarations"
                :key="`vac_${declaration.id}`"
              >
                <td>
                  #{{
                    declaration.vacataire ? declaration.vacataire.agresso : ""
                  }}
                </td>
                <td>
                  {{ declaration.vacataire ? declaration.vacataire.nom : "" }}
                  {{
                    declaration.vacataire ? declaration.vacataire.prenom : ""
                  }}
                </td>
                <td>
                  {{ declaration.college ? declaration.college.nom : "" }}
                </td>
                <td>{{ declaration.nb_heures }}</td>
                <td>{{ declaration.periode_academique }}</td>
                <td>
                  <span
                    v-show="declaration.status == 'en cours'"
                    class="label label-xl label-info label-inline ml-3"
                  >
                    En cours
                  </span>
                  <span
                    v-show="declaration.status == 'valide par doyen'"
                    class="label label-xl label-success label-inline ml-3"
                  >
                    Validée
                  </span>
                  <span
                    v-show="declaration.status == 'refusee'"
                    class="label label-xl label-danger label-inline ml-3"
                  >
                    Refusée
                  </span>
                  <span
                    v-show="declaration.status == 'consulter par daf'"
                    class="label label-xl label-secondary label-inline ml-3"
                  >
                    Consulté par la DAF
                  </span>
                </td>
                <td>
                  {{ declaration.responsable.nom }}
                  {{ declaration.responsable.prenom }}
                </td>
                <td>{{ declaration.date_demande }}</td>
                <td>{{ declaration.date_validation_doyen }}</td>
                <td>{{ declaration.date_consultation_daf }}</td>
                <td class="d-flex">
                  <button
                    v-if="
                      declaration.status == 'en cours' &&
                      admin.role.nom == 'RFC'
                    "
                    @click="delete_declaration_modal(declaration)"
                    class="btn btn-outline-danger btn-sm btn-icon mr-1"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                  <button
                    v-if="
                      declaration.status == 'en cours' &&
                      admin.role.nom == 'DOYEN'
                    "
                    @click="refuse_declaration_modal(declaration)"
                    class="btn btn-outline-danger btn-sm btn-icon mr-1"
                  >
                    <i class="fa fa-times"></i>
                  </button>

                  <button
                    v-if="
                      declaration.status == 'en cours' &&
                      admin.role.nom == 'DOYEN'
                    "
                    @click="valide_declaration_modal(declaration)"
                    class="btn btn-outline-success btn-sm btn-icon"
                  >
                    <i class="fa fa-check"></i>
                  </button>
                  <button
                    @click="show_declaration_modal(declaration)"
                    class="btn btn-outline-success btn-sm btn-icon"
                  >
                    <i class="fa fa-eye"></i>
                  </button>
                </td>
              </tr>
              <tr v-show="!declarations.length">
                <td colspan="12" class="text-center">
                  Aucune déclaration trouvée.
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="16">
                  <jw-pagination
                    :items="alldeclarations"
                    @changePage="onChangePagedeclaration"
                  ></jw-pagination>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="delete_declaration_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#delete_declaration_modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <form action="" method="post">
            <div class="modal-header pb-3">
              <h5 class="modal-title" id="modal_enregistrer_header">
                Supprimer déclaration VH FC
              </h5>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-secondary btn-circle close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body px-0 py-4 pb-8">
              <div class="d-flex justify-content-center">
                <h3 style="color: red">
                  Vous voulez vraiment supprimer cette déclaration VH FC ?
                </h3>
              </div>
            </div>
            <div class="d-flex justify-content-between modal-footer">
              <button
                type="button"
                class="btn bg-D38686 color-FFFFFF px-16 py-3"
                data-dismiss="modal"
                aria-label="Close"
              >
                ANNULER
              </button>
              <button
                @click="delete_declaration()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        opacity="0.3"
                        transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                      />
                      <path
                        d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                      />
                    </g>
                  </svg>
                </span>
                Supprimer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="refuse_declaration_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#refuse_declaration_modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <form action="" method="post">
            <div class="modal-header pb-3">
              <h5 class="modal-title" id="modal_enregistrer_header">
                Refus de la déclaration
              </h5>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-secondary btn-circle close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body px-0 py-4 pb-8">
              <div class="row">
                <label
                  style="
                    color: rgb(17, 27, 131);
                    font-size: 16px;
                    font-weight: 700;
                  "
                  class="col-form-label col-3 text-lg"
                  >Motif<span style="color: #ee2d41">* </span> :</label
                >
              </div>
              <div class="d-flex justify-content-center">
                <textarea
                  v-model="justife"
                  rows="5"
                  class="form-control"
                ></textarea>
              </div>
            </div>
            <div class="d-flex justify-content-between modal-footer">
              <button
                type="button"
                class="btn bg-D38686 color-FFFFFF px-16 py-3"
                data-dismiss="modal"
                aria-label="Close"
              >
                ANNULER
              </button>
              <button
                :disabled="this.justife == null || this.justife == ''"
                @click="refuse_declaration()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <polygon points="0 0 24 0 24 24 0 24" />
                      <path
                        d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        opacity="0.3"
                        transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                      />
                      <path
                        d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                        transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                      />
                    </g>
                  </svg>
                </span>
                Refuser
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="valide_declaration_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#Validedeclaration"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <form action="" method="post">
            <div class="modal-header pb-3">
              <h5 class="modal-title" id="modal_enregistrer_header">
                Validation de la déclaration VH FC
              </h5>

              <button
                type="button"
                class="btn btn-sm btn-icon btn-secondary btn-circle close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body px-0 py-4 pb-8">
              <table class="table">
                <thead style="background-color: #003667; color: white">
                  <tr class="text-center">
                    <td>Professeur</td>
                    <td>Collége</td>
                    <td>Programme</td>
                    <td>Offre</td>
                    <td>Nombre d'heures</td>
                    <td>Détail des activités</td>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="detail in declaration['details']"
                    :key="detail.id"
                    class="text-center"
                  >
                    <td>
                      {{
                        declaration.vacataire ? declaration.vacataire.nom : ""
                      }}
                      {{
                        declaration.vacataire
                          ? declaration.vacataire.prenom
                          : ""
                      }}
                    </td>
                    <td>
                      {{ declaration.college ? declaration.college.nom : "" }}
                    </td>
                    <td>{{ detail.programme.description }}</td>
                    <td>{{ detail.programme.offre }}</td>
                    <td>{{ detail.vh }}</td>
                    <td>
                      {{ detail.commentaire }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="text-center">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Total : {{ declaration.nb_heures }}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div class="d-flex justify-content-between modal-footer">
              <button
                type="button"
                class="btn bg-danger color-FFFFFF px-16 py-3"
                data-dismiss="modal"
                aria-label="Close"
              >
                ANNULER
              </button>
              <button
                @click="valide_declaration()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                <span
                  class="svg-icon svg-icon-white svg-icon-primary svg-icon-2x"
                >
                  <span class="svg-icon svg-icon-success svg-icon-2x">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <polygon points="0 0 24 0 24 24 0 24" />
                        <path
                          d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "
                        />
                      </g>
                    </svg>
                  </span>
                </span>
                Valider
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="show_declaration_modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="#showdeclaration"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content p-5">
          <form action="" method="post">
            <div class="modal-header pb-3">
              <h5 class="modal-title" id="modal_enregistrer_header">
                Validation de la déclaration VH FC
              </h5>

              <button
                type="button"
                class="btn btn-sm btn-icon btn-secondary btn-circle close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body px-0 py-4 pb-8">
              <table class="table">
                <thead style="background-color: #003667; color: white">
                  <tr class="text-center">
                    <td>Professeur</td>
                    <td>Collége</td>
                    <td>Programme</td>
                    <td>Offre</td>
                    <td>Nombre d'heures</td>
                    <td>Détail des activités</td>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="detail in declaration['details']"
                    :key="detail.id"
                    class="text-center"
                  >
                    <td>
                      {{
                        declaration.vacataire ? declaration.vacataire.nom : ""
                      }}
                      {{
                        declaration.vacataire
                          ? declaration.vacataire.prenom
                          : ""
                      }}
                    </td>
                    <td>
                      {{ declaration.college ? declaration.college.nom : "" }}
                    </td>
                    <td>{{ detail.programme.description }}</td>
                    <td>{{ detail.programme.offre }}</td>
                    <td>{{ detail.vh }}</td>
                    <td>
                      {{ detail.commentaire }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="text-center">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Total : {{ declaration.nb_heures }}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div class="d-flex justify-content-between modal-footer">
              <button
                type="button"
                class="btn bg-danger color-FFFFFF px-16 py-3"
                data-dismiss="modal"
                aria-label="Close"
              >
                ANNULER
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VclTable } from "vue-content-loading";

export default {
  props: {
    admin: {},
  },
  components: {
    VclTable,
  },
  data() {
    return {
      alldeclarations: [],
      programmes: [],
      professeurs: [],
      prof: [],
      declarations: [],
      declaration: {},
      vacataire: [],
      professeur: {},
      profLoaded: null,
      declarationsLoaded: null,
      keyword: null,
      search: null,
      nb_heures_old: null,
      nb_heures: null,
      programme_id: null,
      type: "",
      commentaire: null,
      justife: null,
      profNotFound: false,
      disableValideBtn: false,
      selectedItems: [],
      filterEtape: "",

      config: {
        headers: {
          Authorization: "Bearer " + this.admin.api_token,
        },
      },
    };
  },
  watch: {
    search(after, before) {
      if (this.search != "") {
        this.searchdeclarations();
      } else {
        this.reloaddeclarations();
      }
    },
  },

  methods: {
    ajouter_declaration() {
      axios
        .post(
          "/api/create/declaration",
          {
            nb_heures: this.nb_heures,
            commentaire: this.commentaire,
            prof_id: this.professeur.id,
          },
          this.config
        )
        .then((res) => {
          this.nb_heures_old = this.professeur.nb_heures;
          this.professeur = {};
          this.nb_heures = null;
          this.keyword = null;
          this.commentaire = "";
          this.reloaddeclarations();

          $("#ajouter_declaration_modal").modal("hide");
          this.declaration = {};

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            title: "Déclaration VH FC ajoutée avec succès",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          this.nb_heures_old = this.professeur.nb_heures;
          this.professeur = {};
          this.nb_heures = null;
          this.keyword = null;
          this.commentaire = "";
          this.reloaddeclarations();

          $("#ajouter_declaration_modal").modal("hide");
          this.declaration = {};

          let message = "Erreur dans l'ajout du déchargé";
          if (error.response && error.response.data.message) {
            message = error.response.data.message;
          }

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 50000,
            title: message,
            icon: "error",
            confirmButtonText: "Cool",
          });
        });
    },

    onChangePagedeclaration(declarations) {
      // update page of items
      this.declarations = declarations;
    },

    reloaddeclarations() {
      axios
        .get("/api/get/declarations/" + this.admin.id, this.config)
        .then((res) => {
          this.alldeclarations = res.data;
          this.declarationsLoaded = 1;
        });
    },

    delete_declaration_modal(declaration) {
      this.declaration = declaration;
      $("#delete_declaration_modal").modal("show");
    },

    new_declaration() {
      window.location.href = "/administration/declaration-vh-fc/ajouter";
    },

    delete_declaration() {
      axios
        .delete("/api/declaration/delete/" + this.declaration.id, this.config)
        .then((response) => {
          $("#delete_declaration_modal").modal("hide");
          this.declaration = {};
          this.reloaddeclarations();

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Déclaration supprimée !",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    valide_declaration_modal(declaration) {
      this.declaration = declaration;
      this.professeur = declaration.vacataire;
      $("#valide_declaration_modal").modal("show");
    },

    show_declaration_modal(declaration) {
      this.declaration = declaration;
      this.professeur = declaration.vacataire;
      $("#show_declaration_modal").modal("show");
    },

    valide_declaration() {
      axios
        .put(
          "/api/declaration/valide/" +
            this.declaration.id +
            "/" +
            this.admin.id,
          {},
          this.config
        )
        .then((response) => {
          $("#valide_declaration_modal").modal("hide");
          this.declaration = {};
          this.reloaddeclarations();

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Déclaration VH FC validée",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    refuse_declaration_modal(declaration) {
      this.declaration = declaration;
      $("#refuse_declaration_modal").modal("show");
    },

    refuse_declaration() {
      axios
        .put(
          "/api/declaration/refuse/" +
            this.declaration.id +
            "/" +
            this.admin.id,
          {
            justife: this.justife,
          },
          this.config
        )
        .then((response) => {
          $("#refuse_declaration_modal").modal("hide");
          this.declaration = {};
          this.reloaddeclarations();

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            title: "Déclaration VH FC refusée",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  beforeMount() {
    axios
      .get("/api/get/declarations/" + this.admin.id, this.config)
      .then((res) => {
        this.alldeclarations = res.data;
        this.declarationsLoaded = 1;
      });

    axios.get("/api/get/professeurs", this.config).then((res) => {
      this.professeurs = res.data;
    });

    axios
      .get("/api/get/programmesFC/" + this.admin.id, this.config)
      .then((res) => {
        this.programmes = res.data;
      });
  },
};
</script>
